const initialState = {
    doctorPermissions: {},
    doctorLists: [],
    doctorHighlightedRecord: null,
    doctorViewLists: [],
    doctorDetailLists: [],
    doctorTypeData: [],
    doctorType: [],
    hospitalList: [],
    doctorStatus: [],
    changedDoctorStatus: [],
    changedDoctorTypeStatus: [],
    createdDoctorID: '',
    doctorTypeCount: 0,
    loadingDoctor: false,
    loadingDoctorType: false,
    loadingHospitalList: false,
    loadingDoctorGrievance: false,
    loadingDoctorBlacklist: false,
    loadingDoctorAlert: false,
    errorsDoctor: {},
    errorsDoctorType: {},
    errorsDoctorRegister: {},
    errorsDoctorFacility: {},
    errorsSocialmedia: {},
    errorsDoctorGrievance: {},
    errorsDoctorBlacklist: {},
    errorsDoctorAlert: {},
};

const doctorReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_DOCTORLIST_PENDING":
        case "DOCTOR_TYPE_DATA_PENDING":
            return { ...state, loadingDoctorType: true, };
        case "HOSPITAL_LIST_PENDING":
            return { ...state, loadingHospitalList: true, };
        case "ADD_DOCTOR_TYPE_PENDING":
            return { ...state, loadingDoctorType: true, };
        case "UPDATE_DOCTOR_SOCIALMEDIA_PENDING":
        case "ADD_DOCTOR_PENDING":
        case "UPDATE_DOCTOR_PENDING":
        case "DOCTOR_ATTACH_PENDING":
        case "UPDATE_DOCTOR_STATUS_PENDING":
        case "DELETE_DOCTOR_PENDING":
        case "GET_DOCTORLISTBYID_PENDING":
        case "GET_DOCTORVIEWBYID_PENDING":
            return { ...state, loadingDoctor: true, errorsDoctor: {} };
        case "GET_DOCTOR_DETAIL_LISTBYID_PENDING":
            return { ...state, loadingDoctor: true, errorsDoctor: {} };
        case "DOCTOR_GRIEVANCE_PENDING":
            return { ...state, loadingDoctorGrievance: true, errorsDoctorGrievance: {} };
        case "DOCTOR_BLACKLIST_PENDING":
            return { ...state, loadingDoctorBlacklist: true, errorsDoctorBlacklist: {} };
        case "DOCTOR_ALERT_PENDING":
            return { ...state, loadingDoctorAlert: true, errorsDoctorAlert: {} };
        case "DOCTOR_REGISTRATION_PENDING":
            return { ...state, loadingDoctor: true, errorsDoctorRegister: {} };

        case "GET_DOCTORLIST_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                doctorLists: action.payload,
                doctorCount: action.count,
                doctorPermissions: action.permissions,
            };

        case "DOCTOR_TYPE_DATA_FULFILLED":
            return {
                ...state,
                loadingDoctorType: false,
                doctorTypeData: action.payload.data,
                doctorTypeCount: action.count,
            };
        case "HOSPITAL_LIST_FULFILLED":
            return {
                ...state,
                loadingHospitalList: false,
                hospitalList: action.payload.data,
            };
        case "ADD_DOCTOR_TYPE_FULFILLED":
            return {
                ...state,
                loadingDoctorType: false,
                changedDoctorTypeStatus: action.payload,
                errorsDoctorType: {},
            };

        case "ADD_DOCTOR_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.id || state.createdDoctorID,
                errorsDoctor: {},
            };
        case "UPDATE_DOCTOR_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.id || state.createdDoctorID,
                errorsDoctor: {},
            };

        case "UPDATE_DOCTOR_SOCIALMEDIA_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.doctorId || state.createdDoctorID,
                errorsSocialmedia: {},
            };

        case "DOCTOR_REGISTRATION_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.doctorId || state.createdDoctorID,
                errorsDoctorRegister: {},
            };
        case "DOCTOR_ATTACH_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.doctorId || state.createdDoctorID,
                errorsDoctorFacility: {},
            };
        case "DOCTOR_GRIEVANCE_FULFILLED":
            return {
                ...state,
                loadingDoctorGrievance: false,
                doctorLists: action.payload?.data,
                changedDoctorStatus: action.payload,
                errorsDoctorGrievance: {},
            };
        case "DOCTOR_BLACKLIST_FULFILLED":
            return {
                ...state,
                loadingDoctorBlacklist: false,
                doctorLists: action.payload?.data,
                changedDoctorStatus: action.payload,
                errorsDoctorBlacklist: {},
            };
        case "DOCTOR_ALERT_FULFILLED":
            return {
                ...state,
                loadingDoctorAlert: false,
                doctorLists: action.payload?.data,
                changedDoctorStatus: action.payload,
                errorsDoctorAlert: {},
            };
        case "UPDATE_DOCTOR_STATUS_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
                doctorLists: action.payload?.data,
                createdDoctorID: action.payload?.data?.id || state.createdDoctorID,
            };
        case "RESET_CREATED_DOCTOR_ID":
            return {
                ...state,
                createdDoctorID: null,
            };

        case "GET_DOCTORLISTBYID_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                doctorLists: action.payload,
            };

        case "GET_DOCTORVIEWBYID_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                doctorViewLists: action.payload,
            };

        case "GET_DOCTOR_DETAIL_LISTBYID_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                doctorDetailLists: action.payload,
            };

        case "DELETE_DOCTOR_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: action.payload,
            };

        case "RESET_DELETE_DOCTORS_STATUS":
            return {
                ...state,
                loadingDoctor: false,
                changedDoctorStatus: [],
                errorsDoctor: {},
            };

        case "GET_DOCTORLIST_REJECTED":
        case "DOCTOR_TYPE_DATA_REJECTED":
            return {
                ...state,
                loadingDoctorType: false,
                errorsDoctor: action.payload,
            };
        case "HOSPITAL_LIST_REJECTED":
            return {
                ...state,
                loadingHospitalList: false,
                errorsDoctor: action.payload,
            };
        case "ADD_DOCTOR_TYPE_REJECTED":
            return {
                ...state,
                loadingDoctorType: false,
                changedDoctorTypeStatus: [],
                errorsDoctorType: action.payload,
            };
        case "ADD_DOCTOR_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsDoctor: action.payload,
            };
        case "UPDATE_DOCTOR_SOCIALMEDIA_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsSocialmedia: action.payload,
            };
        case "DOCTOR_REGISTRATION_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsDoctorRegister: action.payload,
            };
        case "DOCTOR_ATTACH_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsDoctorFacility: action.payload,
            };
        case "DOCTOR_GRIEVANCE_REJECTED":
            return {
                ...state,
                loadingDoctorGrievance: false,
                errorsDoctorGrievance: action.payload,
            };
        case "DOCTOR_BLACKLIST_REJECTED":
            return {
                ...state,
                loadingDoctorBlacklist: false,
                errorsDoctorBlacklist: action.payload,
            };
        case "DOCTOR_ALERT_REJECTED":
            return {
                ...state,
                loadingDoctorAlert: false,
                errorsDoctorAlert: action.payload,
            };
        case "UPDATE_DOCTOR_REJECTED":
        case "UPDATE_DOCTOR_STATUS_REJECTED":
        case "DELETE_DOCTOR_REJECTED":
        case "GET_DOCTORLISTBYID_REJECTED":
        case "GET_DOCTORVIEWBYID_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsDoctor: action.payload,
            };
        case "GET_DOCTOR_DETAIL_LISTBYID_REJECTED":
            return {
                ...state,
                loadingDoctor: false,
                errorsDoctor: action.payload,
            };
        case "RESET_DELETE_DOCTOR_STATUS":
            return {
                ...state,
                loadingDoctor: false,
                loadingDoctorType: false,
                loadingHospitalList: false,
                loadingDoctorGrievance: false,
                loadingDoctorBlacklist: false,
                loadingDoctorAlert: false,
                errorsDoctor: {},
                errorsDoctorType: {},
                errorsDoctorRegister: {},
                errorsDoctorFacility: {},
                errorsSocialmedia: {},
                errorsDoctorGrievance: {},
                errorsDoctorBlacklist: {},
                errorsDoctorAlert: {},
            };
        case "SET_DOCTOR_HIGHLIGHTED_RECORD":
            return { ...state, doctorHighlightedRecord: action.payload };
        case "CLEAR_DOCTOR_HIGHLIGHTED_RECORD":
            return { ...state, doctorHighlightedRecord: null };
        case "RESET_DOCTOR_STATE":
            return { ...initialState };

        default:
            return state;
    }
};

export default doctorReducer;
